// App
import { useSelector } from 'react-redux';
import { useBlurbLinks } from './useBlurbLinks';
import { useDynamicBlurb } from './useDynamicBlurb';
import type { RootReduxState } from 'app/shared/flux/reducers';

export const useDesktopLogic = () => {
  const area = useSelector((state: RootReduxState) => state.area.area);
  const totalListings = useSelector((state: RootReduxState) => state.listings.totalListings);

  // Handle both mobile and desktop Redux state structures
  const searchSlug = useSelector(
    (state: RootReduxState) => state.DEPRECATED_filter?.searchSlug || state.filter?.search?.slug,
  );

  // Handle both array (desktop) and object (mobile) property type structures
  const isHouse = useSelector((state: RootReduxState) => {
    // Desktop structure: array
    if (state.DEPRECATED_filter?.propertyTypes) {
      return state.DEPRECATED_filter.propertyTypes.length === 1 && state.DEPRECATED_filter.propertyTypes[0] === 'house';
    }
    // Mobile structure: object with boolean flags
    if (state.filter?.propertyTypes) {
      const propertyTypes = state.filter.propertyTypes;
      return (
        propertyTypes.house === true &&
        propertyTypes.any === false &&
        propertyTypes.apartment === false &&
        propertyTypes.condo === false &&
        propertyTypes.duplex === false &&
        propertyTypes.townhouse === false
      );
    }
    return false;
  });

  const { name, resourceId, type } = area;
  const formattedNumberOfListings = totalListings.toLocaleString('en-US', { minimumFractionDigits: 0 });
  const houseOrApartment = isHouse ? 'house' : 'apartment';

  const [dynamicBlurb] = useDynamicBlurb({
    areaType: type,
    areaName: name,
    numberOfListings: formattedNumberOfListings,
    houseOrApartment,
  });

  const [blurbLinks] = useBlurbLinks({
    name,
    areaType: type,
    resourceId,
    searchSlug,
    houseOrApartment,
  });

  return [dynamicBlurb, blurbLinks, houseOrApartment];
};
